import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponseModel } from 'src/app/shared/models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class FaqsService {

  constructor(private http: HttpClient) {}
  addFaq(body) {
    return this.http.post<ApiResponseModel>('api/faq', body);
  }
  addGroupFaq(body) {
    return this.http.post<ApiResponseModel>('api/faq/group', body);
  }
  getGroupFaq() {
    return this.http.get<ApiResponseModel>('api/faq/group');
  }
  editGroupFaq(body, groupID) {
    return this.http.patch<ApiResponseModel>('/api/faq/group/' + groupID, body);
  }
  deleteGroupFaq(groupID) {
    return this.http.delete<ApiResponseModel>('/api/faq/group/' + groupID);
  }
  getFaqs() {
    return this.http.get<ApiResponseModel>('api/faq');
  }
  getFaqById(id) {
    return this.http.get<ApiResponseModel>('/api/faq/' + id);
  }
  editFaq(body, id) {
    return this.http.patch<ApiResponseModel>('/api/faq/' + id, body);
  }

}
